var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotiico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7917 17.709V12.2923C19.2708 12.3965 18.75 12.5007 18.2292 12.5007H17.7083V18.7507H7.29167V11.459C7.29167 8.54232 9.58333 6.25065 12.5 6.25065C12.6042 4.89648 13.2292 3.75065 14.0625 2.81315C13.75 2.39648 13.125 2.08398 12.5 2.08398C11.3542 2.08398 10.4167 3.02148 10.4167 4.16732V4.47982C7.29167 5.41732 5.20833 8.22982 5.20833 11.459V17.709L3.125 19.7923V20.834H21.875V19.7923L19.7917 17.709ZM10.4167 21.8757C10.4167 23.0215 11.3542 23.959 12.5 23.959C13.6458 23.959 14.5833 23.0215 14.5833 21.8757H10.4167ZM21.875 6.77148C21.875 8.75065 20.2083 10.4173 18.2292 10.4173C16.25 10.4173 14.5833 8.75065 14.5833 6.77148C14.5833 4.79232 16.25 3.12565 18.2292 3.12565C20.2083 3.12565 21.875 4.79232 21.875 6.77148Z",
    fill: "#A7A6A6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.3337,
    cy: 6.66667,
    r: 4.16667,
    fill: "#C72828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotiico);
export default __webpack_public_path__ + "static/media/notiico.54c92cb4e285d9a7cbde371c8b63adf7.svg";
export { ForwardRef as ReactComponent };